import React, { Component } from 'react';
import { Classroom, ClassroomList, UnassignedClassroom } from './DesynchronizeComponents';
import { I18n } from 'react-redux-i18n-lite';
import PropTypes from 'prop-types';

class AssignedClassrooms extends Component {
  getSynchronizedClassrooms = () => {
    const { synchronizedClassrooms } = this.props;
    if (synchronizedClassrooms) {
      return synchronizedClassrooms.map((classroom, i) => this.isTeacherInClassroom(classroom, i));
    }
  };

  isTeacherInClassroom = (classroom, i) => {
    const { activeClassrooms } = this.props;

    return !activeClassrooms.map(activeClassroom => activeClassroom.id).includes(classroom.id) ? (
      <UnassignedClassroom key={`unassigned-classroom-${i}`}>
        {classroom.name} {I18n.t('bookContainer.classroomSynchronizedUnassignedClass')}
      </UnassignedClassroom>
    ) : (
      <Classroom key={`assigned-classroom-${i}`}>{classroom.name}</Classroom>
    );
  };

  render() {
    const { synchronizedClassrooms } = this.props;
    if (!synchronizedClassrooms?.length) {
      return null;
    }
    return (
      <ClassroomList>
        {synchronizedClassrooms.map((classroom, i) => this.isTeacherInClassroom(classroom, i))}
      </ClassroomList>
    );
  }
}

AssignedClassrooms.propTypes = {
  synchronizedClassrooms: PropTypes.array,
  activeClassrooms: PropTypes.array
};

export default AssignedClassrooms;
